// 定义框架功能路由
import Login from "../pages/login";
// import Login1 from '../pages/login1';
import Index from "../pages/index";
import Example from "../pages/example";
import NoMenu from "../pages/no_menu";
import SelectCompany from "../pages/SelectCompany/SelectCompany";

const Dashboard = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/selectcompany",
    component: SelectCompany,
  },

  {
    path: "/login1",
    component: Login,
  },
  {
    path: "/index",
    component: Index,
  },
  {
    path: "/example",
    component: Example,
  },
  {
    path: "/nomenu",
    component: NoMenu,
  },
  {
    redirect: true,
    path: "/",
    to: "/login",
    navbarName: "Redirect",
  },
];

export default Dashboard;



// WEBPACK FOOTER //
// ./src/AntD/routes/dashboard.js